/**
 * Public venue day/apply labels (landing + venue page).
 * @see docs/APP_UI_SPEC.md — F3 (transition copy only until day_change_date)
 */
const { getOrdinalSuffix } = require('./dateGeneration');

function formatChangeDate(dateStr) {
  const date = new Date(dateStr + 'T00:00:00');
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  return `${month} ${day}${getOrdinalSuffix(day)}`;
}

function pluralDay(day) {
  return day + 's';
}

/** YYYY-MM-DD in local time for "today" (date-only compare). */
function localDateStringYmd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * When `day_change_date` is still in the future (or today before we treat as complete),
 * show the "moving to…" blurb. After the change date has passed, show only the new day.
 */
function isDayTransitionActive(venue) {
  if (!venue?.new_day_of_week || !venue?.day_change_date) return false;
  const change = String(venue.day_change_date).slice(0, 10);
  const today = localDateStringYmd(new Date());
  return change > today;
}

/**
 * After transition, use the new day; before/during, use the legacy published day.
 */
function effectiveDayOfWeek(venue) {
  if (venue.new_day_of_week && venue.day_change_date && !isDayTransitionActive(venue)) {
    return venue.new_day_of_week;
  }
  return venue.day_of_week;
}

/**
 * Label for the venue's day/time line, e.g. "Tuesdays, 8:00 PM"
 * or "Tuesdays (moving to Fridays from Apr 3rd), 8:00 PM" only while the transition is upcoming.
 */
function venueDayLabel(venue) {
  const inTransition =
    Boolean(venue.new_day_of_week && venue.day_change_date) && isDayTransitionActive(venue);

  if (inTransition) {
    const fromBase = pluralDay(venue.day_of_week);
    const newDays = pluralDay(venue.new_day_of_week);
    const formatted = formatChangeDate(venue.day_change_date);
    return `${fromBase} (moving to ${newDays} from ${formatted}), ${venue.show_time}`;
  }

  const displayDay = effectiveDayOfWeek(venue);
  return `${pluralDay(displayDay)}, ${venue.show_time}`;
}

/**
 * Label for the apply button, e.g. "Apply for Tuesdays"
 * or "Apply for dates" during an upcoming transition.
 */
function venueApplyLabel(venue) {
  if (Boolean(venue.new_day_of_week && venue.day_change_date) && isDayTransitionActive(venue)) {
    return 'Apply for dates';
  }
  return `Apply for ${pluralDay(effectiveDayOfWeek(venue))}`;
}

module.exports = { venueDayLabel, venueApplyLabel };
